module.exports = __webpack_public_path__ + "img/copy2.77dd4acc.svg";